import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';

const routes: Routes = [
  { path: '', redirectTo: 'dform', pathMatch: 'full' }, 
  { path: 'dform', component: DynamicFormComponent },
  { path: '**', redirectTo: 'dform' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/app-routing.module.ts